import { Injectable, inject } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { AsyncValidator, registerAsyncValidatorDecorator } from "@recursyve/ngx-form-generator";
import { isDefined } from "@recursyve/nice-ts-utils";
import { Observable, of, timer } from "rxjs";
import { map, switchMap } from "rxjs/operators";

import { ApiService } from "../../../../../../api/api.service";

export function DistributorSlugIsUnique(): PropertyDecorator {
    return registerAsyncValidatorDecorator({
        name: "DistributorSlugIsUniqueValidator"
    });
}

@Injectable()
export class DistributorSlugIsUniqueValidator extends AsyncValidator {
    private readonly apiService = inject(ApiService);

    public readonly name = "DistributorSlugIsUniqueValidator";

    public validate(control: AbstractControl): Observable<ValidationErrors | null> {
        const controlValue: unknown = control.value;
        if (!isDefined(controlValue) || typeof controlValue !== "string" || controlValue === "") {
            return of(null);
        }

        return timer(200).pipe(
            switchMap(() =>
                this.apiService.distributors.distributorPropertyExists({ slug: controlValue }).pipe(
                    map((isNewDistributorSlugValid) => {
                        if (!isNewDistributorSlugValid) {
                            control.markAsTouched();
                            return { distributor_slug_already_used: true };
                        }

                        return null;
                    })
                )
            )
        );
    }
}
